import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Token-aware tailwind-merge.
 *
 * Tailwind's `text-*` prefix is overloaded — it means font-size (`text-lg`) AND
 * text-color (`text-foreground`). tailwind-merge tells them apart by matching the
 * suffix against t-shirt names (`xs`, `sm`, `md`, `lg`, `2xl`, …); anything it does
 * not recognise falls through to the *color* group.
 *
 * Our scale is all t-shirt names except ONE: `xxs` (9px). Without this entry
 * `cn('text-xxs', 'text-foreground')` treats the two as conflicting and DROPS the
 * size, silently rendering at the inherited size. Re-valuing a name it already
 * knows (our `sm` = 11px) needs nothing — it matches on the name, not the value.
 *
 * Keep in sync with the non-t-shirt keys of `fontSize` in
 * `packages/ui/tailwind.preset.cjs`. The apps that ship their own `cn`
 * (`apps/crm/src/lib/utils.ts`, `apps/payroll/src/lib/utils.ts`) carry the same
 * registration.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['xxs'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
